'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, styled } from '@mui/material/styles';
import clsx from 'clsx';
const StyledAnchor = styled('a')(({ theme, ...props }) => css `
    border: unset;
    background: unset;
    text-decoration: unset;
    outline:  unset;

    box-sizing: border-box;

    cursor: pointer;
    position: relative;
    color: ${theme.tokens.FuelColorTextPrimary};
    font-family: ${theme.tokens.FuelFontFamilyBase};
    font-size: ${theme.tokens.FuelFontSizeSm};
    line-height: ${theme.tokens.FuelLineHeightBase};
    text-align: start;

    width: 100%;
    display: flex;
    align-items: center;
    gap: ${theme.tokens.FuelSpacing2};
    padding-inline: ${theme.tokens.FuelSpacing4};
    padding-block: ${theme.tokens.FuelSpacing2};

    ${props.selected && `
        color: ${theme.tokens.FuelColorBrandPrimary};
        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelected};

        &::after {
            content: "";
            position: absolute;
            width: 3px;
            height: 100%;
            left: 0;
            top: 0;
            background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelectedBar};
        }
    `}

    &:hover, &:focus-visible {
        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultHovered};
    }

    &:active {
        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
    }

    &:focus-visible {
        box-shadow: var(--menu-item-outline-focus);
    }
`);
const MenuItemText = styled('span') `
    flex-grow: 1;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
export const MenuItem = ({ children, className, href, startIcon, endIcon, component: UserLinkComponent, ...props }) => {
    const LinkComponent = UserLinkComponent || (!href ? 'button' : undefined);
    return (_jsxs(StyledAnchor, { ...props, as: LinkComponent, className: clsx('MenuItem-link', className), href: href, children: [startIcon, _jsx(MenuItemText, { className: 'MenuItem-text', children: children }), endIcon] }));
};
